import ReactWhatsapp from "react-whatsapp";
import { FaWhatsapp } from "react-icons/fa";

const WhatsappChat = () => {
  return (
    <div className="whatsapp-float">
      <ReactWhatsapp
        number="+447496360002"
        message="Hi, I want to know more about your services."
        element="div"
      >
        <FaWhatsapp size={40} color="#fff" />
      </ReactWhatsapp>
    </div>
  );
};

export default WhatsappChat;
